import React from 'react';
import { clsx } from 'clsx';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({ children, className, ...props }) => {
  return (
    <div
      className={clsx(
        'bg-gradient-to-br from-basic-white to-brand-beige-tint-1/30',
        'border border-brand-blue/10 rounded-xl shadow-lg hover:shadow-xl',
        'transition-all duration-300 transform hover:-translate-y-1',
        'backdrop-blur-sm relative overflow-hidden group',
        className,
      )}
      {...props}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-brand-blue/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 transform -skew-x-12"></div>
      <div className="relative z-10">{children}</div>
    </div>
  );
};
